import { Text } from '@chakra-ui/react';

import { DesignerOptions } from '@r-core';
import { useFps } from '@r-hooks';

export type FpsInformationProps = {
	options: DesignerOptions;
};

export const FpsInformation = (props: FpsInformationProps): React.ReactElement => {
	const { fps } = props.options;
	useFps('Designer', fps);

	return (
		<div style={{
			zIndex: 10,
			maxWidth: '400px',
			backgroundColor: 'rgba(255, 255, 255, 0.55)',
			border: '1px solid #ccc',
			borderRadius: '8px',
			padding: '15px',
			boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
		}}>
			<h3 style={{ margin: '0 0 15px 0', fontSize: '16px' }}>Fps Info</h3>
			<div style={{ fontSize: '12px' }}>
			{Object.keys(fps).map((key, i) => {
				return (
					<div key={`fps-${i}`}><strong>fps:{key}:</strong> {fps[key].fps} (avg:{fps[key].avg})</div>
				);
			})}
			</div>
		</div>
	);
};
